export default "__VITE_ASSET__Oc4QBhns__"